import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

// Arabic is only available on the dedicated Arabic view of the Middle East page.
const ARABIC_ROUTE = '/about/vidavo-middle-east';

/**
 * Keeps Arabic scoped to the Arabic view: while on the Middle East page with
 * Arabic active nothing changes, but navigating to any other page reverts the
 * language to English (which also hides العربية from the language switcher).
 * Must be rendered inside the Router.
 */
const ArabicRouteGuard = () => {
  const { pathname } = useLocation();
  const { language, changeLanguage } = useLanguage();

  useEffect(() => {
    if (language === 'ar' && pathname !== ARABIC_ROUTE) {
      changeLanguage('en');
    }
  }, [pathname, language, changeLanguage]);

  return null;
};

export default ArabicRouteGuard;
